import { useCallback } from "react";
import { ImportedAccount } from "@common/schemas/domains/accounting/importedAccount.schema";
import { Account } from "@common/types/domains/accounting/account";
import { CreateCoAAccountModal } from "@components/accounting/chartOfAccounts/CoAAccountModal/CreateCoAAccountModal";
import {
    CreateAccountFromRowInitialValues,
    mapCreatedAccountToRow,
} from "./createAccountFromRow";

interface Props {
    account: Pick<ImportedAccount, "id" | "classification">;
    initialValues: CreateAccountFromRowInitialValues;
    entityId: number;
    onMapAccount: (params: {
        importedAccountId: string;
        accountId: string | null;
    }) => void;
    onClose: () => void;
}

export const CoaMappingCreateAccountModal = ({
    account,
    initialValues,
    entityId,
    onMapAccount,
    onClose,
}: Props) => {
    const onAccountsCreated = useCallback(
        (createdAccounts: Account[]) =>
            mapCreatedAccountToRow({
                createdAccounts,
                entityId,
                importedAccountId: account.id,
                onMapAccount,
            }),
        [account.id, entityId, onMapAccount],
    );

    return (
        <CreateCoAAccountModal
            show
            onHide={onClose}
            entityIds={[entityId]}
            hideEntitySelection
            accountName={initialValues.name}
            accountType={initialValues.type}
            accountSubtype={initialValues.subtype}
            parentGroupId={initialValues.parentGroupId}
            availableClassifications={[account.classification]}
            onAccountsCreated={onAccountsCreated}
        />
    );
};
